module.exports = __webpack_public_path__ + "static/media/payment wallet (active).3ccb5b55.svg";